import { Card, CardProps } from 'antd';
import TcBack from 'components/UI/Back/TcBack';
import { FC, ReactNode } from 'react';

interface ITcCard extends CardProps {
  children: ReactNode;
  className?: string;
  back?: string;
  moreLink?: any;
}

const TcCard: FC<ITcCard> = ({ children, title, moreLink, back, ...props }) => {
  return (
    <>
      {back && <TcBack to={back} />}
      <Card title={title ? title : undefined} extra={moreLink ? <a href=''>{moreLink}</a> : undefined} {...props}>
        {children}
      </Card>
    </>
  );
};

export default TcCard;
